import React from 'react';
import { VideoPlayer } from '@thd-olt-component-react/video-player';
import proptypes from 'prop-types';

const { string, number, bool } = proptypes;

const CLASS_NAME = 'sui-object-cover sui-w-full sui-aspect-video';

export default function VideoPlayerWrap({
  videoUrl = '',
  componentId,
  componentPosition = 1,
  shouldUseContentPlayer = false,
  enableB2CRadius = false
}) {
  const isYoutubeVideo = /youtu(be\.com|\.be)/i.test(videoUrl);

  const videoSrcs = {
    videoId: undefined,
    videoSrc: undefined
  };

  if (isYoutubeVideo) {
    const id = (videoUrl.match(/[a-z0-9\-_]{10,}/i) || [''])[0];
    videoSrcs.videoSrc = `https://www.youtube.com/embed/${id}`;

  } else {
    videoSrcs.videoId = (videoUrl.match(/video\/[0-9]{1,}/i) || [''])[0].replace(/video\//i, '');
  }

  const playerKey = `${componentId}-${componentPosition}-${videoSrcs.videoSrc || videoSrcs.videoId}`;

  return (
    <div
      className={CLASS_NAME}
      data-contentful-entry-id={componentId}
      data-contentful-field-id="video"
    >
      <VideoPlayer
        key={playerKey}
        playerId={playerKey}
        className={CLASS_NAME}
        videoId={videoSrcs.videoId}
        videoSrc={videoSrcs.videoSrc}
        aspectRatio={16 / 9}
        shouldUseContentPlayer={shouldUseContentPlayer}
        enableB2CRadius={enableB2CRadius}
      />
    </div>
  );
}

VideoPlayerWrap.propTypes = {
  videoUrl: string,
  componentId: string.isRequired,
  componentPosition: number,
  shouldUseContentPlayer: bool,
  enableB2CRadius: bool
};
